import { Nullable } from "@gsx/common";
import { injectable } from "inversify";
import { SubmitStore } from "../../../../common/src/stores/general/SubmitStore";
import { Api } from "../../../../common/src/api/Api";
import {
    ConferenceBody,
    ConferenceListItem,
} from "@gsx/common/src/types/http/dashboard/conference";
import {
    createConferenceEmptyBody,
    marshalConference,
} from "../../../../common/src/utility/entity/conference";
import omit from "lodash.omit";

@injectable()
export class ConferenceEditStore extends SubmitStore<ConferenceBody> {
    readonly data: Nullable<ConferenceBody> = createConferenceEmptyBody();
    conference: ConferenceListItem | null = null;
    logoFile: FormData = new FormData();

    constructor(private readonly api: Api) {
        super();
    }

    public setConference(conference: ConferenceListItem): void {
        Object.assign(this.data, createConferenceEmptyBody(conference));
        this.conference = conference;
    }

    protected async request(): Promise<void> {
        if (!this.conference) {
            throw new Error("No conference id");
        }

        let body = marshalConference(this.data);
        body = omit(body, "createdAt", "updatedAt");

        await this.api.dashboard.conference.update(
            this.conference.conferenceid,
            body,
            this.logoFile,
        );
    }
}
